import { Link } from "react-router-dom";

export default function FounderTeaser() {
  return (
    <section className="relative py-32 md:py-40 bg-ivory-alt">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-10 md:gap-16 items-center">
        <div className="col-span-12 md:col-span-5">
          <div className="img-zoom overflow-hidden aspect-[4/5]">
            <img
              src="https://customer-assets.emergentagent.com/job_hii-connect-1131/artifacts/96lzk32k_IMG_5135.JPG"
              alt="Yashank Kalia — Founder, Indiora Journeys"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="col-span-12 md:col-span-6 md:col-start-7">
          <div className="eyebrow mb-6">From the Founder</div>
          <h2 className="font-serif text-5xl md:text-6xl tracking-tight font-light leading-[1]">
            "We do not <em className="italic text-indigo_deep">sell</em> itineraries — <br />
            we <em className="italic text-terracotta">compose</em> them."
          </h2>
          <p className="mt-10 text-lg text-ink/75 leading-[1.85] font-light max-w-xl">
            Indiora Journeys began with a quiet conviction — that the finest
            travel through South Asia should be measured not in miles, but
            in moments. Every journey we craft is a small, private answer
            to that conviction.
          </p>
          <div className="mt-10 flex items-center gap-6">
            <div>
              <div className="font-serif text-2xl italic text-indigo_deep">
                Yashank Kalia
              </div>
              <div className="text-[10px] tracking-widest3 uppercase text-ink/55 mt-1">
                Founder & Managing Director
              </div>
            </div>
            <div className="hidden sm:block w-16 h-px bg-ink/20" />
            <Link
              to="/about"
              className="text-[11px] tracking-widest2 uppercase font-semibold border-b border-ink pb-1 hover:text-terracotta hover:border-terracotta transition-colors"
            >
              Read His Story
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
